<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		name: 'app',
	}
</script>
<style>
	body,
	div,
	dl,
	dt,
	dd,
	ul,
	ol,
	li,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	pre,
	form,
	fieldset,
	input,
	textarea,
	p,
	blockquote,
	th,
	td {
		padding: 0;
		margin: 0;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	fieldset,
	img {
		border: 0;
	}

	address,
	caption,
	cite,
	code,
	dfn,
	em,
	strong,
	th,
	var {
		font-weight: normal;
		font-style: normal;
	}

	ol,
	ul {
		list-style: none;
	}

	caption,
	th {
		text-align: left;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-weight: normal;
		font-size: 100%;
	}

	q:before,
	q:after {
		content: ”;
	}

	abbr,
	acronym {
		border: 0;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.fl_r {
		display: flex;
		flex-direction: row;
	}

	.fl_c {
		display: flex;
		flex-direction: column;
	}

	.fl_j_s {
		justify-content: flex-start;
	}

	.fl_j_e {
		justify-content: flex-end;
	}

	.fl_j_b {
		justify-content: space-between;
	}

	.fl_j_a {
		justify-content: space-around;
	}

	.fl_j_l {
		justify-content: space-evenly;
	}

	.fl_j_c {
		justify-content: center
	}

	.fl_a_s {
		align-items: flex-start;
	}

	.fl_a_e {
		align-items: flex-end;
	}

	.fl_a_c {
		align-items: center;
	}

	.line2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/*autoprefixer: on */
		-webkit-line-clamp: 2;
		word-break: break-all;
	}

	.line3 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/*autoprefixer: on */
		-webkit-line-clamp: 3;
		word-break: break-all;
	}

	.line4 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/*autoprefixer: on */
		-webkit-line-clamp: 4;
		word-break: break-all;
	}

	.line5 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/*autoprefixer: on */
		-webkit-line-clamp: 5;
		word-break: break-all;
	}

	.line1 {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>